const func = {
  /**
   *  显示流程图
   */
  showFlowImage: function(a) {
    //存在子流程查看流程图显示的子流程的流程图
    if(a.processDefinitionId){
      let p = {batchId:a.batchId, processDefinitionId:a.processDefinitionId, applicationId:a.applicationId};
      p.width = a.width;
      p.height = a.height;
      PF.show('processChartViewer', p);
      return ;
    }

    PF.api.process.getLatestProcessData(a).then(res=>{
      if(res.success) {
        var processDefinitionId = res.result.processDefinitionId;
        var batchId = res.result.batchId;
        if(null != processDefinitionId){
          let p = {batchId:batchId, processDefinitionId:processDefinitionId, applicationId:a.applicationId};
          p.width = a.width;
          p.height = a.height;
          PF.show('processChartViewer', p);
        }
      }
    });
  },
  showFlowInterfering:function(a){
    if(!a.businessName && !a.businessId){
      PF.message('info', $lang('标题或业务ID不能为空!'));
      return;
    }
    PF.show('processInterfering', a);
  },
  /**
   * 办理过程
   */
  showFlowProcess:function(a){
    if(a.length==0){
      PF.message('info', $lang('请选择需要查看办理过程的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要查看办理过程的文件'));
      return;
    }
    PF.show('transactionProcess',{batchId:a[0].batchId, taskId:a[0].id});
  },
  /**
   * 查看运转跟踪
   * @param a
   */
  showFlowWorkTrack:function(a){
    if(a.length==0){
      PF.message('info', $lang('请选择需要查看运转跟踪的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要查看运转跟踪的文件'));
      return;
    }
    PF.show('flowWorktrack',{taskId:a[0].id, appId:a[0].applicationId, formId:a[0].formEntityKey, businessId:a[0].businessId});
  },
  /**
   * AB角抢办
   * @param a
   * @param b
   */
  abGrab:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要抢办的数据'));
      return;
    }
    let taskIds=[];
    a.forEach(t =>{
      taskIds.push(t.id);
    });
    PF.api.process.batchAbGrab(taskIds).then(res=>{
      if(res.success) {
        b.refreshTable();
      }
    });
  },
  /**
   * 批量阅毕
   */
  batchCommitCircular:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要阅毕的数据'));
      return;
    }
    let taskIds=[];
    a.forEach(t =>{
      taskIds.push(t.id);
    });
    PF.api.process.batchCommitCircular(taskIds).then(res=>{
      if(res.success) {
        b.refreshTable();
      }
    });
  },
  /**
   * 批量转办
   */
  batchTransfer:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要转办的文件'));
      return;
    }
    let taskIds=[];
    a.forEach(t =>{
      taskIds.push(t.id);
    });
    PF.show('turnProcess',{taskIds:taskIds}, function(params){
      PF.api.process.batchTransfer(taskIds, params).then( res =>{
        var data = res.result;
        if(data && !data.success){
          if(data.errorType==="comment"){
            if(data.errorCode==='comment_check_stop'){
              PF.message('info', $lang('当前环节存在必填意见环节,不支持批量办理!'));
              return;
            }else if(data.errorCode==='comment_check_remind'){
              PF.message('info', $lang('当前环节存在提示填写意见环节,不支持批量办理!'));
              return;
            }
          }else{
            var errorMsg = '';
            if(data.errorMsg){
              errorMsg ='[错误信息:'+data.errorMsg+']';
            }
            PF.message('info', $lang('转办失败'+errorMsg+'!'));
            return;
          }
        }else if(res.success){
          PF.message($lang('转办成功'));
          b.refreshTable();
        }
      });
    });
  },
  /**
   * 取回
   */
  taken:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要取回的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要取回的文件'));
      return;
    }
    let param = {containClaimed: true};
    let takenParam = {};
    if(b && b.fullAuthType){
      param.fullAuthType = b.fullAuthType;
      takenParam.fullAuthType = b.fullAuthType;
    }
    //let param = {unlimited: true};
    PF.api.process.checkCanTaken(a[0].id, param).then(res=>{
      if(res.success){
        let result = res.result;
        if(!result.canTaken){
          PF.message('info', $lang('此文件'+result.reason+'不可取回'));
          return;
        }
        let message = '';
        if(result.assignees){
          message= $lang('{}已签收',null,$lang(result.assignees))+",";
        }
        PF.confirm(message+$lang('确定取回选中的文件吗？'), $lang('提示'), {
          type: 'warning'
        }).then(() => {
          PF.api.process.taken(a[0].id,takenParam).then(res=>{
            if(res.success) {
              b.refreshTable();
            }
          });
        }).catch(() => {

        });
      }
    });
  },
  /**
   * 协同撤办
   */
  revoke:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要撤办的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要撤办的文件'));
      return;
    }
    let param = {containClaimed: true};
    PF.api.process.checkCanTaken(a[0].id, param).then(res=>{
      if(res.success){
        let result = res.result;
        if(!result.canTaken){
          PF.message('info', $lang('此文件'+result.reason+'不可撤办'));
          return;
        }
        let message = '';
        if(result.assignees){
          message= result.assignees+'已签收,';
        }
        PF.confirm($lang(message+'确定撤办选中的文件吗？'), $lang('提示'), {
          type: 'warning'
        }).then(() => {
          PF.api.process.taken(a[0].id).then(res=>{
            if(res.success) {
              b.refreshTable();
            }
          });
        }).catch(() => {

        });
      }
    });
  },
  /**
   * 协同转发
   */
  transmit:function(a, b){
    PF.message('info', $lang('此功能将在后期开发，请耐心等待...'));
  },
  /**
   * 取消委托
   */
  cancelDelegation:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要取消委托的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要取消委托的文件'));
      return;
    }
    PF.confirm($lang('确定取消委托选中的文件吗？'), $lang('提示'), {
      type: 'warning'
    }).then(() => {
      PF.api.process.resolve(a[0].id, {checkGoOut:false}).then(res=>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }).catch(() => {

    });
  },
  /**
   * 交还委托人
   */
  returnClient:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要交还委托人的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要交还委托人的文件'));
      return;
    }
    PF.confirm($lang('确定把选中的文件交还委托人吗？'), $lang('提示'), {
      type: 'warning'
    }).then(() => {
      PF.api.process.resolve(a[0].id, {checkGoOut:true}).then(res=>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }).catch(() => {

    });
  },
  /**
   * 挂起
   */
  suspend: function (a, b, key) {
    if(a.length==0){
      PF.message('info', $lang('请选择需要挂起的文件'));
      return;
    }
    let params = [];
    a.forEach(t =>{
      params.push({
        moduleId:t.moduleId,
        businessId:t.businessId,
        taskId:t.id
      })
    });
    PF.confirm($lang('确定挂起选中的文件吗？'), $lang('提示'), {
      type: 'warning'
    }).then(() => {
      PF.api.process.batchSuspendReleaseWH(params).then(res=>{
        if(res.success) {
          b.refreshTable();
          b.refreshBtnSum('recycle', key);
        }
      }).catch(()=>{
      });
    }).catch(() => {
    });
  },
  /**
   * 激活
   */
  activate:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要恢复的文件'));
      return;
    }
    let businesses=[];
    a.forEach(t =>{
      businesses.push({businessId:t.businessId, batchId:t.batchId, draftsDocId: t.draftsDocId, moduleId:t.moduleId});
    });
    PF.confirm($lang('确定恢复选中的文件吗？'), $lang('提示'), {
      type: 'warning'
    }).then(() => {
      PF.api.process.batchActivate(businesses).then(res=>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }).catch(() => {

    });
  },
  markDelete:function(a, b){
    if(a.length==0){
       PF.message('info', $lang('请选择需要删除的文件'));
       return;
     }
     let businesses=[];
     a.forEach(t =>{
       businesses.push({businessId:t.businessId, draftsDocId:t.draftsDocId, batchId:t.batchId, formEntityKey:t.formEntityKey, moduleId:t.moduleId});
     });
     PF.confirm($lang('您确定删除选中的文件吗？'), $lang('提示'), {
      type: 'warning'
     }).then(() => {
         PF.api.process.batchMarkDelete(businesses).then(res=>{
           if(res.success) {
              b.refreshTable();
           }
         });
     }).catch(() => {

     });
  },
  /**
   * 彻底删除 无法找回
   */
  thoroughDelete:function(a, b){
    PF.message('info', $lang('此功能将在后期开发，静待...'));
    /*if(a.length==0){
      PF.message('info', '请选择需要彻底删除的文件');
      return;
    }
    let businessIds=[];
    a.forEach(t =>{
      businessIds.push(t.businessId);
    });
    PF.confirm('此操作执行之后将无法恢复，请谨慎操作！您确定彻底删除选中的文件吗？', '提示', {
      type: 'warning'
    }).then(() => {
      PF.api.process.batchThoroughDelete(businessIds).then(res=>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }).catch(() => {

    });*/
  },

   /**
   *  连续待办
   */
  continuousTodo(){
    PF.show("page",{id:"5a0fc6dcc3574e67"});
  },

  /**
   * 关注
   */
  attention:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要关注的文件'));
      return;
    }
    let add_taskIds=[];
    let del_draftsDocIds=[];
    a.forEach(t =>{
      if(t.attentionStatus){
        del_businessIds.push(t.draftsDocId);
      }else{
        add_taskIds.push(t.id);
      }
    });
    if(add_taskIds.length> 0 && del_draftsDocIds.length> 0){
      PF.api.business.removeAttentionByBusiness(del_draftsDocIds).then(res=>{
        if(res.success) {
          return PF.api.business.addAttention(add_taskIds);
        }
      }).then(res =>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }else if(add_taskIds.length> 0){
      PF.api.business.addAttention(add_taskIds).then(res =>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }else{
      PF.api.business.removeAttentionByBusiness(del_draftsDocIds).then(res =>{
        if(res.success) {
          b.refreshTable();
        }
      });
    }
  },
  /**
   * 取消关注
   */
  removeAttention:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要取消关注的文件'));
      return;
    }
    var ids = a.map(item => item.id);
    PF.api.business.removeAttention(ids).then(res =>{
      if(res.success) {
        b.refreshTable();
      }
    });
  },
  /**
   * 催办
   */
  urge:function(a, b){
    if(a.length==0){
      PF.message('info', $lang('请选择需要催办的文件'));
      return;
    }
    if(a.length> 1){
      PF.message('info', $lang('请选择一条需要催办的文件'));
      return;
    }
    let r = a[0];
    let id = r.id;
    if(r.type==4 && r.yzStatus) id = r.yzStatus;
    PF.api.process.checkAllCanUrge(a[0].batchId,id).then(res=>{
      if(res.success){
        let result = res.result;
        if(!result.canUrge){
          PF.message('info', $lang('此文件不可催办'));
          return;
        }
        PF.show('urgeProcess',{data:result.tasks, businessName:a[0].businessName}, function(data){
          PF.api.business.addUrge(data).then(res=>{
            if(res.success) {
              PF.message($lang('催办成功'));
            }
          });
        });
      }
    });
  }
}

export default func





// WEBPACK FOOTER //
// ./src/modules/index/common/BpmFunction.js